import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonSlides, ModalController } from '@ionic/angular';

@Component({
  selector: 'app-image-view',
  templateUrl: './image-view.component.html',
  styleUrls: ['./image-view.component.scss'],
})
export class ImageViewComponent implements OnInit {

  @ViewChild('slides', {static: true}) slides: IonSlides;
  @Input() index?: number = null;
  @Input() images: string[] = [];

  slideOpts = null;

  constructor(
    private modalCtrl: ModalController,
  ) { }

  ngOnInit() {
    this.slideOpts = {
      initialSlide: this.index,
      preloadImages: true,
      lazy: false,
      speed: 400
    };
  }

  ionViewWillEnter() {
    setTimeout(() => {
      this.slides.update().then(() => {});
    }, 50);
  }

  close() {
    this.modalCtrl.dismiss();
  }
}
